import { createSelector } from 'reselect';
import { AppState } from 'src/config/appState';

const getVideosState = (state: AppState) => state.videos;

const extractId = (_state: AppState, id: string) => id;

export const getVideos = (state: AppState) => getVideosState(state).data;

export const getVideoUrlById = createSelector(getVideos, extractId, (videos, targetId):
    | string
    | null => {
    const video = videos.find(({ id }) => id == targetId);

    return video ? video.url : null;
});
